import "./container.css";
import "./ReadyCta.css";

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#ready-cta-star-clip)">
      <path
        d="M8.00008 0.666504L6.00008 5.99984L0.666748 7.99984L6.00008 9.99984L8.00008 15.3332L10.0001 9.99984L15.3334 7.99984L10.0001 5.99984L8.00008 0.666504Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="ready-cta-star-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const FEATURES = [
  "Competitive & Transparent Interest Rates",
  "Flexible Repayment Options",
  "100% Digital, Paperless Process",
  "24×7 Helpline",
];

const ReadyCta = () => {
  return (
    <section className="ready-cta-section w-full">
      <div className="container-8xl">
        <div className="ready-cta-card">
          <div className="ready-cta-bg" aria-hidden="true" />
          <div className="ready-cta-content">
            <span className="ready-cta-badge">
              <StarIcon />
              Special Offer
            </span>

            <h2 className="ready-cta-heading">Ready to Take Control of Your Finances?</h2>

            <p className="ready-cta-subtext">
              Join over 1 million users who trust us with their financial future. Get started in
              <br />
              minutes with no hidden fees or complicated paperwork.
            </p>

            <div className="ready-cta-features">
              {FEATURES.map((feature) => (
                <span key={feature} className="ready-cta-feature">
                  <StarIcon />
                  {feature}
                </span>
              ))}
            </div>

            <a
              href={import.meta.env.VITE_WEBSITE_LINK}
              target="_blank"
              rel="noreferrer"
              className="ready-cta-btn"
            >
              Apply Now
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyCta;
